import * as React from "react";
import { SVGProps } from "react";

const Pillar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2474 2474" {...props}>
    <path fill="#00ff24" d="M0 0h2474.3v2474.3H0V0z" />
    <path d="M1507.42 1017.2v477.87H741.36v285.73l143.02 143.02c78.46 78.46 143.64 142.71 145.18 142.71 1.24 0 2.16-63.94 2.16-142.09v-142.09h762.98V826.3l-143.64-143.64-143.64-143.64v478.18z" />
    <path d="M741.36 920.52v191.52h386.12V729H741.36v191.52z" />
  </svg>
);

export default Pillar;
